// extracted by mini-css-extract-plugin
module.exports = {"details":"Details_details__t1Zh0","summary":"Details_summary__6sOfk","arrow":"Details_arrow__ov_U_","indentChildren":"Details_indentChildren__6Uc3Y"};